import { FormElement, Select } from 'mailup-web-components'
import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputIdField = () => {
  const intl = useIntl()
  const [isDirty, setIsDirty] = useState(false)

  const { IdField } = useRecoilValue(step2State)
  const { dynamicFields } = useRecoilValue(workflowCommonDataState)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleChangeIdField = (value) => {
    setWorkflowDetailsState((prev) => ({ ...prev, IdField: value }))
    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const invalid = isDirty && !IdField

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.CustomFieldLabel'
      })}
      required
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <Select
        value={IdField}
        options={dynamicFields}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectFieldPlaceholder'
        })}
        onChange={handleChangeIdField}
        error={invalid}
      />
    </FormElement>
  )
}

export default InputIdField
